import { render } from "./BuildingSignupsModal.vue?vue&type=template&id=995b193a&scoped=true"
import script from "./BuildingSignupsModal.vue?vue&type=script&lang=js"
export * from "./BuildingSignupsModal.vue?vue&type=script&lang=js"

import "./BuildingSignupsModal.vue?vue&type=style&index=0&id=995b193a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-995b193a"]])

export default __exports__